<template>
  <!-- <div v-if="!has_perm('view_incurred_liabilitities_report')">
    <div class="col-md-12">
      <h1 style="text-align: center; color: red;">{{$t('common.not_permission')}} !</h1>
    </div>
  </div> -->
  <div
    v-if="
      has_perm('view_incurred_liabilitities_report') || GET_ACCOUNT_DATA.id == 1
    "
    style="border: 0px solid black; width:100%;"
  >
    <div class="welcome" style="border: 0px solid red;">
      <row
        style="border:0px solid green;position: inherit;display:contents;width:100%;"
      >
        <div class="box box-primary" style="width:100%">
          <div class="box-header with-border">
            <div
              style="text-align:center; font-size: 17px;text-align:left;color:#5b6c7f;margin-bottom:20px;"
            >
              <b>{{ $t("report.report_accounting_home_liability.title") }}</b>
            </div>

            <div class="col-md-12 col-ld-12 col-sd-12">
              <div class="col-sm-3 col-md-3 col-lg-3">
                <div class="form-group">
                  <div class="input-group date">
                    <div class="input-group-addon">
                      <i class="fa fa-calendar">
                        <label>
                          <span style="margin-left:5px;display:inline-block;"
                            >{{ $t("service_history.date_from") }}:</span
                          >
                        </label>
                      </i>
                    </div>
                    <date-picker
                      :config="options"
                      :value="search.from_date"
                      v-model="search.from_date"
                    ></date-picker>
                  </div>
                </div>
              </div>

              <div class="col-sm-3 col-md-3 col-lg-3">
                <div class="form-group">
                  <div class="input-group date">
                    <div class="input-group-addon">
                      <i class="fa fa-calendar">
                        <label>
                          <span style="margin-left:5px;display:inline-block;"
                            >{{ $t("service_history.date_to") }}:</span
                          >
                        </label>
                      </i>
                    </div>
                    <date-picker
                      :config="options"
                      :value="search.to_date"
                      v-model="search.to_date"
                    ></date-picker>
                  </div>
                </div>
              </div>

              <div class="col-sm-2 col-md-2 col-lg-2">
                <button
                  type="button"
                  class="btn btn-labeled btn-warning pull-left"
                  @click="onSearch"
                >
                  <span class="btn-label">
                    <i class="glyphicon glyphicon-search"></i>
                  </span>
                  {{ $t("common.search") }}
                </button>
              </div>
            </div>
          </div>

          <div class="box-body">
            <table class="table tableLiability">
              <thead class="text-center header-row">
                <tr class="td1">
                  <th class="text-center header-row td1" rowspan="2">
                    {{
                      $t(
                        "report.report_accounting_home_liability.table_result_search.stt"
                      )
                    }}
                  </th>
                  <th class="text-center header-row td1" rowspan="2">
                    {{
                      $t(
                        "report.report_accounting_home_liability.table_result_search.customer_code"
                      )
                    }}
                  </th>
                  <th class="text-center header-row td1" rowspan="2">
                    {{
                      $t(
                        "report.report_accounting_home_liability.table_result_search.user__last_name"
                      )
                    }}
                  </th>
                  <th class="text-center header-row td1" rowspan="2">
                    {{
                      $t(
                        "report.report_accounting_home_liability.table_result_search.apartment__apartment_code"
                      )
                    }}
                  </th>

                  <th class="text-center header-row td1" colspan="2">
                    {{
                      $t(
                        "report.report_accounting_home_liability.table_result_search.closing_balance_begin"
                      )
                    }}
                  </th>
                  <th class="text-center header-row td1" colspan="2">
                    {{
                      $t(
                        "report.report_accounting_home_liability.table_result_search.closing_balance_midle"
                      )
                    }}
                  </th>
                  <th class="text-center header-row td1" colspan="2">
                    {{
                      $t(
                        "report.report_accounting_home_liability.table_result_search.closing_balance_end"
                      )
                    }}
                  </th>

                  <!-- <th
                    class="text-center header-row td1"
                    rowspan="2"
                  >{{$t('report.report_accounting_home_liability.table_result_search.total')}}</th> -->
                </tr>
                <tr class="td1">
                  <th class="text-center header-row">
                    {{
                      $t(
                        "report.report_accounting_home_liability.table_result_search.in_debt"
                      )
                    }}
                  </th>
                  <th class="text-center header-row">
                    {{
                      $t(
                        "report.report_accounting_home_liability.table_result_search.yes"
                      )
                    }}
                  </th>
                  <th class="text-center header-row">
                    {{
                      $t(
                        "report.report_accounting_home_liability.table_result_search.in_debt"
                      )
                    }}
                  </th>
                  <th class="text-center header-row">
                    {{
                      $t(
                        "report.report_accounting_home_liability.table_result_search.yes"
                      )
                    }}
                  </th>
                  <th class="text-center header-row">
                    {{
                      $t(
                        "report.report_accounting_home_liability.table_result_search.in_debt"
                      )
                    }}
                  </th>
                  <th class="text-center header-row">
                    {{
                      $t(
                        "report.report_accounting_home_liability.table_result_search.yes"
                      )
                    }}
                  </th>
                </tr>
              </thead>
              <tbody class>
                <tr
                  class="header-row"
                  v-for="(entry, index1) in search_result"
                  :key="entry.id"
                  :uId="entry.id"
                >
                  <template>
                    <td
                      class="header-row"
                      v-for="(key, index2) in fields"
                      :key="index2"
                    >
                      <p
                        v-if="
                          key['key'] == 'closing_trade_payable_midle' ||
                            key['key'] == 'closing_trade_payable_min' ||
                            key['key'] == 'closing_trade_payable_max' ||
                            key['key'] == 'closing_trade_payable_yes_min' ||
                            key['key'] == 'closing_trade_payable_yes_max' ||
                            key['key'] == 'closing_trade_payable_yes_midle' ||
                            key['key'] == 'total'
                        "
                        style="text-align:right"
                      >
                        {{ formatTotalFee(entry[key["key"]], true) }}
                      </p>
                      <p v-else-if="key['key'] == 'STT'">{{ index1 + 1 }}</p>
                      <p v-else>{{ entry[key["key"]] }}</p>
                    </td>
                  </template>
                </tr>
              </tbody>
              <tfoot v-if="search_result.length > 0">
                <tr class="td1">
                  <th class="text-center header-row td1" colspan="4">
                    {{
                      $t(
                        "report.report_accounting_home_liability.table_result_search.total"
                      )
                    }}
                  </th>

                  <th class="text-right header-row td1" colspan="1">
                    {{ summaryByCondition("b.closing_trade_payable_min") }}
                  </th>
                  <th class="text-right header-row td1" colspan="1">
                    {{ summaryByCondition("b.closing_trade_payable_yes_min") }}
                  </th>

                  <th class="text-right header-row td1" colspan="1">
                    {{ summaryByCondition("b.closing_trade_payable_midle") }}
                  </th>

                  <th class="text-right header-row td1" rowspan="1">
                    {{
                      summaryByCondition("b.closing_trade_payable_yes_midle")
                    }}
                  </th>

                  <th class="text-right header-row td1" colspan="1">
                    {{ summaryByCondition("b.closing_trade_payable_max") }}
                  </th>
                  <th class="text-right header-row td1" colspan="1">
                    {{ summaryByCondition("b.closing_trade_payable_yes_max") }}
                  </th>
                  <!-- <th
                    class="text-center header-row td1"
                    colspan="1"
                  >{{$t('report.report_accounting_home_liability.table_result_search.closing_balance_end')}}</th> -->
                </tr>
              </tfoot>
            </table>

            <vue-good-table
              v-if="false"
              :columns="columns"
              :rows="rows"
              :select-options="{ enabled: false }"
              :search-options="{
                enabled: true,
                placeholder: $t('component_address_book.search')
              }"
              :line-numbers="true"
              :pagination-options="{
                enabled: true,
                nextLabel: $t('component_address_book.next'),
                prevLabel: $t('component_address_book.prev'),
                rowsPerPageLabel: $t('component_address_book.rows_per_page'),
                ofLabel: $t('component_address_book.of'),
                pageLabel: $t('component_address_book.page')
              }"
            >
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'customer_fullname'">
                  <span>{{
                    getFullName(
                      props.row.user_first_name,
                      props.row.user_last_name
                    )
                  }}</span>
                </span>
                <span v-else>{{ props.formattedRow[props.column.field] }}</span>
              </template>
            </vue-good-table>
          </div>
        </div>

        <loading
          :active.sync="isLoading"
          :can-cancel="false"
          color="#1E90FF"
        ></loading>
      </row>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
// import LTEChart from '@/components/LTEChart'
// import LTETable from "@/components/LTETable.vue";
// import LTEButton from "@/components/LTEButton.vue";
import Loading from "vue-loading-overlay";
// import Paginator from "@/components/Paginator.vue";
import datePicker from "vue-bootstrap-datetimepicker";
// // import DateRangePicker2 from '@/components/LTEDateRangePicker2.vue'
// import Select2 from '@/components/LTESelect2Input.vue'

// import XLSX from "xlsx";
import moment from "moment";

// import vue-good-table
import "vue-good-table/dist/vue-good-table.css";
import { VueGoodTable } from "vue-good-table";

// vue-input-tag
// import InputTag from "vue-input-tag";
import utils from '@/lib/utils';
import i18n from "../../lang";

export default {
  name: "ReportAccountingHomeLiability",
  data() {
    return {
      fields: [
        {
          key: "STT",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "customer_code",
          sortable: true,
          class: "text-center"
        },
        {
          key: "full_name",
          sortable: true,
          class: "text-center"
        },
        {
          key: "apartment__apartment_code",
          sortable: true,
          sortDirection: "desc"
        },

        {
          key: "closing_trade_payable_min",
          sortable: true,
          class: "text-center"
        },
        {
          key: "closing_trade_payable_yes_min",
          sortable: true,
          class: "text-center"
        },

        {
          key: "closing_trade_payable_midle",
          sortable: true,
          class: "text-center"
        },
        {
          key: "closing_trade_payable_yes_midle",
          sortable: true,
          class: "text-center"
        },

        {
          key: "closing_trade_payable_max",
          sortable: true,
          class: "text-center"
        },
        {
          key: "closing_trade_payable_yes_max",
          sortable: true,
          class: "text-center"
        }

        // # [loitt] #1279: THÊM TỔNG TIỀN CHO BÁO CÁO CÔNG NỢ PHÁT SINH
        // {
        //   key: "total",
        //   sortable: true,
        //   class: "text-center"
        // }
      ],
      STT: 0,
      gridDataList: [],
      hdBackground:
        "background-color: #4b646f;color:white;border:1px solid white;",
      gridColumns: [
        { text: "common.nonumber", isHidden: true },
        { text: "accounting_home_liability.customer_code", isHidden: true },
        { text: "accounting_home_liability.customer_fullname", isHidden: true },
        { text: "accounting_home_liability.apartment_code", isHidden: true },
        { text: "accounting_home_liability.invoice_code", isHidden: true },
        { text: "accounting_home_liability.explaination", isHidden: true },
        { text: "accounting_home_liability.cash", isHidden: true },
        { text: "accounting_home_liability.total", isHidden: true },
        {
          text: "accounting_home_liability.closing_trade_payable",
          isHidden: true
        }
      ],
      search: {
        from_date: null,
        to_date: null
      },
      options: {
        format: "DD/MM/YYYY",
        useCurrent: false
      },

      search_result: [],

      boxStyle: false,
      paginatorItem: {
        commit_function: "GET_ACCOUNTING_HOME_LIABILITY_LIST"
      },

      // Mã KH, Tên KH, Mã Căn, Mã Chứng Từ, Diễn Giải, Số Tiền, Số Dư
      columns: [
        {
          label: this.$t("accounting_home_liability.customer_code"),
          field: "customer_code"
        },
        {
          label: this.$t("accounting_home_liability.customer_fullname"),
          field: "customer_fullname"
        },
        {
          label: this.$t("accounting_home_liability.apartment_code"),
          field: "apartment_code"
        },
        {
          label: this.$t("accounting_home_liability.invoice_code"),
          field: "invoice_code"
        },
        {
          label: this.$t("accounting_home_liability.explaination"),
          field: "explaination"
        },
        {
          label: this.$t("accounting_home_liability.cash"),
          field: "cash"
        },
        {
          label: this.$t("accounting_home_liability.total"),
          field: "total"
        },
        {
          label: this.$t("accounting_home_liability.closing_trade_payable"),
          field: "closing_trade_payable"
        }
      ],
      rows: [],

      isLoading: false
    };
  },
  watch: {
    accounting_home_liability_data: function() {
      this.rows = this.accounting_home_liability_data;

      this.gridDataList = [];
      this.accounting_home_liability_data.forEach((item, i) => {
        let id = item.id;
        let nonumber =
          i + 1 + (this.PAGINATION.page - 1) * this.PAGINATION.size;
        let customer_code = item.customer_code;
        let customer_fullname = this.getFullName(
          item.user_first_name,
          item.user_last_name
        );
        let apartment_code = item.apartment_code;
        let invoice_code = item.invoice_code;
        let explaination = item.explaination;
        let cash = utils.formatNumber(utils.makeRoundNumber(item.cash));
        let total = 0;
        let closing_trade_payable = utils.formatNumber(
          utils.makeRoundNumber(item.closing_trade_payable)
        );

        let data = {
          id: id,
          "common.nonumber": nonumber,
          "accounting_home_liability.customer_code": customer_code,
          "accounting_home_liability.customer_fullname": customer_fullname,
          "accounting_home_liability.apartment_code": apartment_code,
          "accounting_home_liability.invoice_code": invoice_code,
          "accounting_home_liability.explaination": explaination,
          "accounting_home_liability.cash": cash,
          "accounting_home_liability.closing_trade_payable": closing_trade_payable,
          "accounting_home_liability.total": total
        };
        this.gridDataList.push(data);
      });
    }
  },
  computed: {
    ...mapGetters("accountingHomeLiabilityModule", {
      accounting_home_liability_data: "ACCOUNTING_HOME_LIABILITY_LIST",
      search_accounting_home_liability_data:
        "SEARCH_ACCOUNTING_HOME_LIABILITY_LIST_DATA"
    }),
    ...mapGetters([
      "GET_SNACK_BAR",
      "PAGINATION",
      "PAGINATOR",
      "PAGE_ARROW",
      "GET_ACCOUNT_DATA"
    ])
  },
  methods: {
    //
    // [author]: loitt
    // Ex: let name = "b.closing_trade_payable_min"
    // summaryByCondition("b.closing_trade_payable_min")
    //
    summaryByCondition: function(name) {
      let total = this.search_result.reduce(function(a, b) {
        return a + eval(name);
      }, 0);
      return this.formatTotalFee(total, true);
    },

    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    getFullName(firstname, lastname) {
      return utils.getFullName(firstname, lastname, i18n.locale);
    },
    importExcel: function() {
      this.$router.push({
        name: "AccountingHomeLiabilityImportExcel",
        params: {
          id: 0
        }
      });
    },

    onPrevPagination: function() {
      const data = {
        url: this.PAGE_ARROW.prev,
        commit_funtion: "GET_ACCOUNTING_HOME_LIABILITY_LIST"
      };
      this.PAGINATION_PREV_PAGE(data);
    },
    onNextPagination: function() {
      const data = {
        url: this.PAGE_ARROW.next,
        commit_funtion: "GET_ACCOUNTING_HOME_LIABILITY_LIST"
      };
      this.PAGINATION_NEXT_PAGE(data);
    },
    onPagination: function(data) {
      this.GET_ACCOUNTING_HOME_LIABILITY_LIST(data);
    },

    initializeDate() {
      this.search.from_date = moment(new Date(), this.options.format).format("DD/MM/YYYY hh:mm:ss");
      this.search.to_date = moment(new Date(), this.options.format).format("DD/MM/YYYY hh:mm:ss");
    },

    onSearch() {
      this.isLoading = true;

      let from_date = utils.formatSqlDate(this.search.from_date, this.options.format, "DD/MM/YYYY hh:mm:ss");
      let to_date = utils.formatSqlDate(this.search.to_date, this.options.format, "DD/MM/YYYY hh:mm:ss");

      const data = {
        from_date: from_date,
        to_date: to_date
      };
      this.SEARCH_ACCOUNTING_HOME_LIABILITY_LIST(data).then(
        function(res) {
          this.search_result = res.data;
          // res.forEach(v => {
          //     this.invoiceDataList.push(data);
          // });
          // this.invoiceDataList = res;
          this.isLoading = false;
          // if (this.invoiceDataList.length > 0) {
          //   // this.onPrintInvoice()
          // }
        }.bind(this)
      );
    },

    formatTotalFee(total_fee, isFormat = false) {
      if (total_fee != undefined) {
        total_fee = utils.makeRoundNumber(total_fee);
        let rs = total_fee.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
        return rs == null ? 0 : rs;
        // return  (rs == 0 && isFormat) ? "-" : rs;
      }
      return 0;
    },

    getSTT() {
      this.STT++;
      let stt = this.STT;
      return stt;
    },

    ...mapActions("accountingHomeLiabilityModule", [
      "GET_ACCOUNTING_HOME_LIABILITY_LIST",
      "SEARCH_ACCOUNTING_HOME_LIABILITY_LIST"
    ]),
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "PAGINATION_PREV_PAGE",
      "PAGINATION_NEXT_PAGE"
    ])
  },
  mounted() {
    const data = {
      params: {
        page: 1
      }
    };
    this.GET_ACCOUNTING_HOME_LIABILITY_LIST(data);

    this.initializeDate();
  },
  components: {
    "vue-good-table": VueGoodTable,
    // "lte-button": LTEButton,
    loading: Loading,
    "date-picker": datePicker

    // "lte-table": LTETable,
    // paginator: Paginator
  }
};
</script>
<style scoped></style>

<style scoped>
.search {
  box-shadow: none;
  border-color: #d2d6de;
  z-index: 2;
  float: left;
  margin-bottom: 8px;
  margin-right: 5px;
  height: 30px;
  font-size: 12px;
  line-height: 1.5;
  border-radius: 3px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.size-180 {
  width: 180px;
}

.search-tools {
  padding-right: 0px;
  padding-left: 0px;
  width: auto;
}
.select-option-status {
  margin-top: -12px;
  display: inline-block;
}

.colorbutton {
  background-color: yellow;
  color: black;
}
@media only screen and (max-width: 1000px) {
  .select-option-status {
    float: none;
    margin-top: 4px;
  }
}
@media only screen and (max-width: 768px) {
  .select-option-status {
    float: none;
    margin-top: 0px;
  }
}

.header-row {
  border: 1px solid;
}

.tableLiability .td1 {
  vertical-align: middle;
  /* width: 50%; */
  /* height: 30px; */
  background: lightblue;
  /* padding: 20px; */
  font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// src/views/Report/ReportAccountingHomeLiability.vue